// Below enum comes from Hymots Core Backend
export enum StatusEnum {
  DENEY_BASLADI = 1,
  DENEY_BASLAMADI = 2,
  DENEY_BITTI = 3,
  DENEY_BITMEDI = 4,
  HESAPLAMA_BASLADI = 5,
  HESAPLAMA_BASLAMADI = 6,
  HESAPLAMA_BITTI = 7,
  HESAPLAMA_ICIN_DENEY_DURUMU_BULUNMUYOR = 8,
  HESAPLAMA_ISTEGI_HATALI = 9,
  HESAPLAMA_DIZINI_BULUNMUYOR = 10,
  HESAPLAMA_BASARILI_OYUN_SAYISI_YETERSIZ = 11,
  YENI_DENEY_BASKA_DENEY_KOSULDUGU_ICIN_KABUL_EDILMEDI = 12,
  DENEY_KAPATILDI = 13,
  DENEY_HATA = 254,
  HESAPLAMA_HATA = 255,
}

export enum DatabaseTypeEnum {
  Recent = 1,
  Archive = 2,
}
